import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import helpIconMovingUrl from "../assets/help-icon-moving.png?url";
import { OnboardingProps } from "../common";

export const HelpIconMovingOnboarding = memo(function HelpIconMovingOnboarding({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  return (
    <RedoFeatureNotificationCard
      actionText="Got it"
      description="Click here to get help!"
      image={helpIconMovingUrl}
      onAction={handleComplete}
      onDismiss={handleDismiss}
      title="The help icon has moved"
    />
  );
});
